// extracted by mini-css-extract-plugin
export default {"infoCards":"ColumnPage_infoCards__pFoxp","header":"ColumnPage_header__6ma0P","title":"ColumnPage_title__7jlkX","search":"ColumnPage_search__6DHId"};